import React from "react";
import "./styles/CiColorSystem.scss";
import { useTranslation } from "react-i18next";
const CiColorSystem = () => {
  const { t } = useTranslation();
  return (
    <>
      <div className="ci_color_system_wrap">
        <h2>{t("aboutUs.ci.colorSystem.title")}</h2>
        <div className="bi_main_wrap">
          <div className="ment">{t("aboutUs.ci.colorSystem.ment")}</div>
          <div className="imgs_wrap">
            <div className="img_box">
              <img src="/imgs/ci_color_image_01.png" alt="ci_color_image" />
            </div>
            <div className="img_box">
              <img src="/imgs/ci_color_image_02.png" alt="ci_color_image" />
            </div>
            <div className="img_box">
              <img src="/imgs/ci_color_image_03.png" alt="ci_color_image" />
            </div>
          </div>
        </div>
        <div className="bi_color_wrap">
          <div className="pantone_wrap">
            <div className="text_wrap">
              <div className="code">C70 M46 Y75 K40 </div>
              <div className="name">
                Olivel Green <br /> {t("aboutUs.ci.colorSystem.green")}
              </div>
            </div>
            <div className="img_box">
              <img src="/imgs/ci_color_main.png" alt="main_pantone_color" />
            </div>
          </div>
          <div className="pantone_wrap">
            <div className="text_wrap">
              <div className="code">C0 M8 Y15 K30 </div>
              <div className="name">
                Warm Gray <br /> {t("aboutUs.ci.colorSystem.gray")}
              </div>
            </div>
            <div className="img_box">
              <img src="/imgs/ci_color_sub.png" alt="sub_pantone_color" />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CiColorSystem;
